import { css } from '@microsoft/fast-element';
import { cardStyles } from '../card/card.styles';
import { checkboxStyles } from '../checkbox/checkbox.styles';
import { selectableCardStyles } from '../../styles/patterns/selectable-card';

export const checkboxCardStyles = css`
    ${cardStyles}
    ${checkboxStyles}
    ${selectableCardStyles}
`;
